<template>
    <div class="form-horizontal">
        <div class="form-group">
            <label for="appointment_date" class="col-xs-12 col-md-4 control-label">{{ $t('components.appointment.choose_datetime') }}</label>
            <div class="col-xs-12 col-md-8 has-feedback" >
                <Datetime id="appointment_date"
                          type="datetime"
                          :value-zone="TIMEZONE_DEFAULT"
                          :zone="TIMEZONE_DEFAULT"
                          v-model="newAppointment.date"
                          :phrases="{ok: $t('common.time.choose_datetime'), cancel: $t('common.time.cancel_datetime')}"
                          input-class="form-control"></Datetime>
                <span class="glyphicon glyphicon-calendar form-control-feedback" aria-hidden="true"></span>
            </div>
        </div>
        <div class="form-group">
            <label for="client-admin-options" class="col-xs-12 col-md-4 control-label">{{ $t('components.appointment.associate_user') }}</label>
            <div class="col-xs-12 col-md-8">
                <select class="form-control" id="client-admin-options" name="client-admin-options" v-model="newAppointment.client_admin">
                    <option v-for="clientAdmin in clientsAdminAvailable" v-bind:key="clientAdmin.id" :value="clientAdmin.id">
                        {{clientAdmin.first_name}} {{clientAdmin.last_name}}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <label for="location-options" class="col-xs-12 col-md-4 control-label">{{ $t('components.appointment.associate_location') }}</label>
            <div class="col-xs-12 col-md-8">
                <select class="form-control" id="location-options" name="location-options" v-model="newAppointment.location">
                    <option :value="null">NA</option>
                    <option v-for="location in locationsAvailable" v-bind:key="location.id" :value="location.id">
                        {{location.name}}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <label for="appointment_is_online" class="col-xs-12 col-md-4 control-label"></label>
            <div class="col-xs-12 col-md-8">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" id="appointment_is_online" name="appointment_is_online" v-model="newAppointment.is_online"> {{ $t('components.appointment.appointment_online') }}
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group" v-if="!hideRepeat">
            <label for="appointment_repeat" class="col-xs-12 col-md-4 control-label"></label>
            <div class="col-xs-12 col-md-8">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" id="appointment_repeat" name="appointment_repeat" v-model="newAppointment.repeat"> {{ $t('components.appointment.duplicate_date') }}
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group" v-show="newAppointment.repeat">
            <label for="appointment_repeat_day_of_week" class="col-xs-12 col-md-4 control-label">{{ $t('components.appointment.repeat') }}</label>
            <div class="col-xs-12 col-md-8">
                <select class="form-control" id="appointment_repeat_day_of_week" name="appointment_repeat_day_of_week" v-model="newAppointment.repeat_day_of_week">
                    <option value="0">{{ $t('common.time.monday') }}</option>
                    <option value="1">{{ $t('common.time.tuesday') }}</option>
                    <option value="2">{{ $t('common.time.wednesday') }}</option>
                    <option value="3">{{ $t('common.time.thursday') }}</option>
                    <option value="4">{{ $t('common.time.friday') }}</option>
                    <option value="5">{{ $t('common.time.saturday') }}</option>
                    <option value="6">{{ $t('common.time.sunday') }}</option>
                </select>
            </div>
        </div>
        <div class="form-group" v-show="newAppointment.repeat">
            <label for="appointment_repeat_until_date" class="col-xs-12 col-md-4 control-label">{{ $t('components.appointment.until') }}</label>
            <div class="col-xs-12 col-md-8 has-feedback" >
                <Datetime
                        id="appointment_repeat_until_date"
                        type="date"
                        :value-zone="TIMEZONE_DEFAULT"
                        :zone="TIMEZONE_DEFAULT"
                        v-model="newAppointment.repeat_until_date"
                        :phrases="{ok: $t('common.time.choose_datetime'), cancel: $t('common.time.cancel_datetime')}"
                        input-class="form-control"
                        :min-datetime="newAppointment.date"
                ></Datetime>
                <span class="glyphicon glyphicon-calendar form-control-feedback" aria-hidden="true"></span>
            </div>
        </div>
        <div class="form-group">
            <label for="appointment_email_notify" class="col-xs-12 col-md-4 control-label"></label>
            <div class="col-xs-12 col-md-8">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" id="appointment_email_notify" name="appointment_email_notify" v-model="newAppointment.notify"> {{ $t('common.send_notification_question') }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Datetime} from "vue-datetime";
    import 'vue-datetime/dist/vue-datetime.css'
    import {Utils, moveUpDatetimePopup} from "../../common/utils";
    import {getAllClientAdmin, getAllLocation} from "../../api";
    import {TIMEZONE_DEFAULT} from "../../common/constants";
    import {StorageHelper} from "../../common/storageHelper";

    export default {
        name: "AppointmentForm",
        components: {Datetime},
        props: {
            newAppointmentProp: {
                type: Object,
                required: true
            },
            hideRepeat: {
                type: Boolean,
                default: false
            }
        },
        data: () => {
            return {
                TIMEZONE_DEFAULT: StorageHelper.getUser().timezone || TIMEZONE_DEFAULT,
                newAppointment: {
                    date: null,
                    client_admin: null,
                    location: null,
                    repeat: null,
                    is_online: false,
                    notify: true,
                    repeat_day_of_week: null,
                    repeat_until_date: null,

                },
                clientsAdminAvailable: [],
                locationsAvailable: []
            }
        },
        async mounted () {
            this.newAppointment = this.newAppointmentProp;
            let date = new Date();
            date.setDate(date.getDate() + 1);
            date.setHours(12);
            date.setMinutes(0);

            moveUpDatetimePopup()

            this.newAppointment.repeat_until_date = date.toISOString();
            this.newAppointment.date = date.toISOString();

            this.clientsAdminAvailable = await getAllClientAdmin();
            this.locationsAvailable = await getAllLocation();
        },
        watch: {
            newAppointmentProp: function(newVal) {
                this.newAppointment = newVal;
            },
            clientsAdminAvailable: function(newVal) {
                if (newVal.length > 0) {
                    this.newAppointment.client_admin = newVal[0].id
                }
            },
            newAppointment: {
                handler(newVal) {
                    this.$emit('change', newVal)
                },
                deep: true,
            },
            'newAppointment.date'(newVal) {
                this.newAppointment.repeat_day_of_week = Utils.getDayOfWeekISO(newVal);
                this.newAppointment.repeat_until_date = newVal
            }
        }
    }
</script>
